/* eslint-disable @typescript-eslint/no-explicit-any */
import { SortDirection } from "@/api/shared";
import { downloadFile, getNameFromFileKey } from "@/utils";
import { useState } from "react";
import { useNotify } from "react-admin";
import { FileFormat } from "@/types";

export const useDownloadFile = ({
  apiFunc,
  localStorageFileKey,
  filterValues,
  format = FileFormat.CSV,
  pagination,
  sort,
}: {
  apiFunc: (args: any) => Promise<Blob>;
  localStorageFileKey: string;
  filterValues: any;
  format?: FileFormat;
  pagination?: {
    page: number;
    perPage: number;
  };
  sort?: {
    sortBy: string;
    sortDirection: SortDirection;
  };
}) => {
  const notify = useNotify();

  const [isLoading, setIsLoading] = useState(false);

  const download = async () => {
    try {
      setIsLoading(true);
      const blob = await apiFunc({
        ...filterValues,
        ...pagination,
        ...sort,
      });
      downloadFile(blob, localStorageFileKey, format);
      notify(
        `${getNameFromFileKey(localStorageFileKey)} ${format.toUpperCase()} file downloaded!`,
        {
          type: "success",
        },
      );
    } catch (error) {
      const errorTitle = `Error downloading the ${getNameFromFileKey(
        localStorageFileKey,
      )} ${format.toUpperCase()} file`;

      notify(errorTitle, { type: "error" });
      console.error(`${errorTitle}: ${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, download };
};
